import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { Fact } from '@/types';

export const useGetDocFacts = ({
  docId,
  caseId,
}: {
  docId: string | null | undefined;
  caseId: string | null | undefined;
}) => {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      docIds: [docId],
      paginated: false,
    },
  });

  return useQuery<Fact[], Error>(
    [QueryEntity.CaseFacts, { docId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/facts/query`, fetchConfigPOST);
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    { refetchOnWindowFocus: false, enabled: !!caseId && !!docId },
  );
};
